export default __webpack_public_path__ + "static/media/gmail.34a462e4.png";